<template>
  <NewGlassCard
    id="contract-details"
    :class="
      this.$vuetify.breakpoint.xl
        ? 'xl-design-details-page-element default-mb'
        : 'default-mb'
    "
    class="z-index-0"
    :title="$t('consumption_devices.order_details.title')"
  >
    <div>
      <RowItem
        first
        class="row-item"
        :title="$t('consumption_devices.order_details.request_date')"
        :editable="false"
      >
        {{ formattedRequestDate }}
      </RowItem>
      <!-- Auftragsnummer -->
      <RowItem
        class="row-item"
        :title="$t('consumption_devices.order_details.case_number')"
        :editable="false"
      >
        {{ consumptionDevicesOrder.case_number || '-' }}
      </RowItem>
      <!-- Anschlussadresse -->
      <RowItem
        class="row-item"
        field="updateInstallationAddress"
        :title="$t('consumption_devices.order_details.connection_address')"
        :editable="true"
        @edit="
          $emit('edit-component', {
            component: 'ConsumptionDevicesAddressComponent',
            location: 'ConsumptionDevicesOrderDetails',
            properties: {
              coordinates: consumptionDevicesOrder.coordinates,
              address: consumptionDevicesOrder.address,
            },
          })
        "
      >
        <div v-html="formattedAddress"></div>
      </RowItem>
      <!-- Kontaktdaten -->
      <RowItem
        class="row-item"
        :title="$t('consumption_devices.order_details.contact_data')"
        :editable="true"
        @edit="
          $emit('edit-component', {
            component: 'ConsumptionDevicesContactDataComponent',
            location: 'ConsumptionDevicesOrderDetails',
            properties: {
              consumptionDevicesOrder,
            },
          })
        "
      >
        <div v-html="formattedApplicantData"></div>
      </RowItem>
    </div>
  </NewGlassCard>
</template>

<script>
import { NewGlassCard } from '@newnetzportal/netzportal-webapp-storybook-components';
import { personalDataObject } from '../../helpers/transformToPresentableData';
import RowItem from '../feed-in-system-details/RowItem.vue';

export default {
  name: 'ConsumptionDevicesOrderDetails',
  components: {
    NewGlassCard,
    RowItem,
  },
  props: {
    consumptionDevicesOrder: {
      type: Object,
      required: true,
    },
  },
  computed: {
    formattedRequestDate() {
      if (!this.consumptionDevicesOrder.request_date) return '-';
      const date = new Date(this.consumptionDevicesOrder.request_date);
      return date.toLocaleDateString('de-DE');
    },
    formattedAddress() {
      if (!this.consumptionDevicesOrder.address) return '-';
      const address = this.consumptionDevicesOrder.address;
      return `${address.street} ${address.street_number}, ${address.zip} ${address.city}`;
    },
    formattedApplicantData() {
      if (!this.consumptionDevicesOrder.applicant) return '-';

      let contactDataText = '';

      // Add the applicant role information if available
      if (this.consumptionDevicesOrder.applicant_role) {
        contactDataText += `${this.$t(
          'consumption_devices.order_details.applicant_is_also'
        )} ${this.$t(
          `consumption_devices.order_details.${this.consumptionDevicesOrder.applicant_role}`
        )}<br> <br>`;
      }

      // Add applicant section
      const applicant = this.consumptionDevicesOrder.applicant;
      const applicantRole = this.consumptionDevicesOrder.applicant_role;

      // Only show the Elektrofachbetrieb label for plant constructor role
      if (
        applicantRole === 'plant_constructor' ||
        applicantRole === 'service_provider'
      ) {
        contactDataText += '(Elektrofachbetrieb/Installateur):<br>';
      }

      // Add applicant personal data
      contactDataText += personalDataObject(applicant);

      // Add address if available
      if (applicant.address) {
        contactDataText += `${applicant.address.street} ${applicant.address.street_number}<br>`;
        contactDataText += `${applicant.address.zip} ${applicant.address.city}<br>`;
      }

      // Add contact information
      if (applicant.phone_number) {
        contactDataText += `${this.$t('contact_data_component.phone')}: ${
          applicant.phone_number
        }<br>`;
      }

      if (applicant.email) {
        contactDataText += `${this.$t('contact_data_component.email')}: ${
          applicant.email
        }<br>`;
      }

      if (applicant.preferred_contact_channel) {
        contactDataText += `${this.$t(
          'contact_data_component.preferred_contact'
        )}: ${this.$t(
          `contact_data_component.${applicant.preferred_contact_channel}`
        )}<br>`;
      }

      // Add end customer information if available
      if (this.consumptionDevicesOrder.end_customer) {
        const endCustomer = this.consumptionDevicesOrder.end_customer;

        // Add separator between applicant and end customer
        contactDataText += '<br><hr><br>';
        contactDataText += `${this.$t(
          'consumption_devices.order_details.end_customer'
        )}:<br>`;

        // Add end customer personal data
        contactDataText += personalDataObject(endCustomer);

        // Add address if available
        if (endCustomer.address) {
          contactDataText += `${endCustomer.address.street} ${endCustomer.address.street_number}<br>`;
          contactDataText += `${endCustomer.address.zip} ${endCustomer.address.city}<br>`;
        }

        // Add contact information
        if (endCustomer.phone_number) {
          contactDataText += `${this.$t('contact_data_component.phone')}: ${
            endCustomer.phone_number
          }<br>`;
        }

        if (endCustomer.email) {
          contactDataText += `${this.$t('contact_data_component.email')}: ${
            endCustomer.email
          }<br>`;
        }

        if (endCustomer.preferred_contact_channel) {
          contactDataText += `${this.$t(
            'contact_data_component.preferred_contact'
          )}: ${this.$t(
            `contact_data_component.${endCustomer.preferred_contact_channel}`
          )}<br>`;
        }
      }

      return contactDataText;
    },
  },
};
</script>

<style scoped lang="scss">
.row-item {
  margin-block: 1px;
}
</style>
